<template>
  <div class="accident">
    <div class="message">
      <img class="ico" src="@/assets/images/user/blueTipIcon.png"/>
      <p>共享车辆在平台共享期间，发生事故，由平台协助处理，共享车主无需承担相关费用，仅提供相应资料协助处理</p>
    </div>
    <div class="content">
      <div class="carCon" v-for="(item,index) in list" :key="index">
        <div class="item title">
          <span>事故状态</span>
          <span class="value status">{{item.Status}}</span>
        </div>
        <div class="item">
          <span>事故时间</span>
          <span class="value">{{item.Time}}</span>
        </div>
        <div class="item">
          <span>事故地点</span>
          <span class="value">{{item.Adress}}</span>
        </div>
        <div class="item">
          <span>事故车辆</span>
          <span class="value">{{item.CarNumber}}</span>
        </div>
        <div class="item">
          <span>处理方式</span>
          <span class="value">{{item.Mode}}</span>
        </div>
      </div>
      <div class="nodata" v-if="list.length == 0">
        <img class="img" src="@/assets/images/peccancy/nodata.png"/>
        <div>暂无事故~</div>
      </div>
      <div v-else class="end">没有更多啦~</div>
    </div>
  </div>
</template>

<script>
  import { accidentList } from "@/utils/api";
  export default {
    name: 'accident',
    data: function () {
      return {
        CarID:0,
        list:[]
      };
    },
    created() {
      this.CarID = this.$route.query.CarID || 0;
    },
    mounted() {
      this.initData();
    },
    methods: {
      async initData(){
        let res = await accidentList({
          data:{
            CarId:this.CarID
          }
        })
        if(res.Code == 100){
          for(var i=0;i<res.Data.length;i++){
            res.Data[i].Time = res.Data[i].Time.slice(0,16).replace('T','  ');
            if(res.Data[i].Status == 2){
              res.Data[i].Status = '已完成';
            }else{
              res.Data[i].Status = '处理中';
            }
          }
          this.list = res.Data;
        }
      }
    }
  }

</script>

<style lang="scss" scoped type="text/scss">
  .accident{
    position: absolute;
    width: 100%;
    top: 110px;
    bottom: 0px;
    left: 0px;
    background: #fff;
    .message{
      display: flex;
      justify-content: space-between;
      padding: 20px;
      box-sizing: border-box;
      color: #027FFF;
      font-size: 26px;
      .ico{
        margin-right: 10px;
        width: 40px;
        height: 40px;
      }
    }
    .content{
      padding: 25px;
      box-sizing: border-box;
      .carCon{
        margin-bottom: 40px;
        padding: 10px 0;
        box-sizing: border-box;
        box-shadow:-3px 6px 15px #ccc;
        -webkit-box-shadow:-3px 6px 15px #ccc ;
        .item{
          display: flex;
          justify-content: space-between;
          padding: 22px 34px;
          box-sizing: border-box;
          color: #9F9F9F;
          font-size: 26px;
          .value{
            color: #000;
          }
          span{
            min-width: 70px;
          }
        }
        .title{
          border-bottom: 1px solid #E7E6E6;/*no*/
          .status{
            color: #FF572C;
          }
        }
      }
      .nodata {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        margin-top: 200px;
        box-sizing: border-box;
        color: #9F9F9F;
        .img{
          width: 300px;
          height: 200px;
          margin-bottom: 20px;
        }
      }
      .end{
        margin-top: 30px;
        text-align: center;
        color: #797979;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/car/accident.vue